import Input, { Props as InputProps } from '../Input'

type Props = InputProps<string>

const Text = (props: Props) => <Input<string> type="text" {...props} />

export default Text
